import { gql } from '@apollo/client';

export const TRIGGER_WEBHOOK = gql`
  mutation TriggerWebhook($entityId: String!, $eventType: WebhookEventType!, $accountId: String!) {
    triggerWebhook(entityId: $entityId, eventType: $eventType, accountId: $accountId)
  }
`;
